import { BASIC_POKEMON, ENERGY, STAGE_1, STAGE_2 } from '../constants';
import { evolveReason, evolveTargets, optionReason } from '../ActiveGame/options';
import { trainerPlay } from '../Trainer/trainerPlay';
import { addToBenchCancel, attachCancel, evolveCancel, startAttachFlow, startBenchFlow, startEvolveFlow } from '../Pokemon/actions';

export const MAKE_ACTIVE = 'make-active';
export const BENCH = 'bench';
export const ATTACH = 'attach';
export const EVOLVE = 'evolve';
export const TRAINER = 'trainer';

/**
 * What a card in your hand can be used for now: the one place that decides it, for the hand menu and for dragging.
 * Whether it's allowed, and why not, comes from the server's options.
 *
 * @returns {{ kind: string, reason: ?string, start: ?Function, cancel: ?Function, play: ?object }} start and cancel are
 *   the action creators that begin and abandon the card's flow (picking a spot on the board); make-active and
 *   Trainers have none. A Trainer has `play` instead: how it's played (trainerPlay)
 */
export function handCardAction(card, { settingUp, hasActive, options }) {
  const cardTypes = card.get('cardTypes').map(cardType => cardType.get('id')).toArray();
  const position = card.get('order');

  if (cardTypes.includes(BASIC_POKEMON)) {
    if (settingUp && !hasActive) {
      return { kind: MAKE_ACTIVE, reason: null, start: null, cancel: null };
    }
    return { kind: BENCH, reason: optionReason(options && options.get('bench')), start: () => startBenchFlow(position), cancel: addToBenchCancel };
  }

  if (cardTypes.includes(ENERGY)) {
    return { kind: ATTACH, reason: optionReason(options && options.get('attach')), start: () => startAttachFlow(position), cancel: attachCancel };
  }

  if (cardTypes.includes(STAGE_1) || cardTypes.includes(STAGE_2)) {
    const reason = evolveTargets(options, position).length ? null : (evolveReason(options, position) || optionReason(undefined));
    return { kind: EVOLVE, reason, start: () => startEvolveFlow(position), cancel: evolveCancel };
  }

  const play = trainerPlay(card, options);
  return { kind: TRAINER, reason: play.reason, start: null, cancel: null, play };
}
